import React from 'react';
import { AnimationZoomIn } from '@tink/core/src/components/atoms/AnimationZoomIn/AnimationZoomIn';
import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';
import { BalancedText } from '@tink/core/src/components/atoms/BalancedText/BalancedText';
import { Stack } from '../../../../../components/atoms/Stack/Stack';
import { Text } from '../../../../../components/atoms/Text/Text';

type Props = {
  delay?: number;
  figure: JSX.Element;
  text?: React.ReactNode;
};

export const OverlayContainer: React.FC<Props> = ({ delay, figure, text }) => {
  const { isDesktop } = userAgent;

  return (
    <Stack
      alignItems="center"
      verticalPadding={isDesktop ? 'xxlarge' : 'normal'}
      aria-live="polite"
      aria-atomic="true"
    >
      <Stack alignItems="center" justifyContent="center" gap="normal">
        {figure}
        {text && (
          <AnimationZoomIn delay={delay || 0}>
            <Text data-testid="overlay-container-content" align="center">
              <BalancedText>{text}</BalancedText>
            </Text>
          </AnimationZoomIn>
        )}
      </Stack>
    </Stack>
  );
};
